// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"c672d949","592":"7eb65534"}[chunkId] + ".chunk.js";
};